function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useTheme } from 'styled-components';
var BirminghamMidshiresIcon = function BirminghamMidshiresIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 2.83333C6.93739 2.83333 2.83333 6.93739 2.83333 12C2.83333 17.0626 6.93739 21.1667 12 21.1667C17.0626 21.1667 21.1667 17.0626 21.1667 12C21.1667 6.93739 17.0626 2.83333 12 2.83333ZM12 16C12.5128 16 12.9355 16.3827 12.9933 16.8827L13 17C13 17.5128 12.6173 17.9355 12.1173 17.9933L12 18C11.4872 18 11.0645 17.6173 11.0067 17.1173L11 17C11 16.4872 11.3827 16.0645 11.8827 16.0067L12 16ZM13 6V14H11V6H13Z",
    fill: "currentColor"
  }));
};
BirminghamMidshiresIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BlackHorseIcon = function BlackHorseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.9757C12.2891 17.9757 12.5314 17.8779 12.7269 17.6824C12.9225 17.4868 13.0202 17.2445 13.0202 16.9555C13.0202 16.6664 12.9225 16.4241 12.7269 16.2286C12.5314 16.033 12.2891 15.9353 12 15.9353C11.7109 15.9353 11.4686 16.033 11.2731 16.2286C11.0775 16.4241 10.9798 16.6664 10.9798 16.9555C10.9798 17.2445 11.0775 17.4868 11.2731 17.6824C11.4686 17.8779 11.7109 17.9757 12 17.9757ZM11.0527 13.3603H12.9473V5.78136H11.0527V13.3603ZM12.0021 24C10.3424 24 8.78236 23.6851 7.32198 23.0552C5.86157 22.4253 4.59123 21.5704 3.51096 20.4906C2.43066 19.4108 1.57543 18.141 0.945255 16.6813C0.315085 15.2215 0 13.6618 0 12.0021C0 10.3424 0.314948 8.78236 0.944845 7.32198C1.57474 5.86157 2.42959 4.59123 3.50938 3.51096C4.58919 2.43066 5.85897 1.57543 7.31872 0.945255C8.77845 0.315085 10.3382 0 11.9979 0C13.6576 0 15.2176 0.314948 16.678 0.944844C18.1384 1.57474 19.4088 2.42959 20.489 3.50938C21.5693 4.58919 22.4246 5.85897 23.0547 7.31872C23.6849 8.77845 24 10.3382 24 11.9979C24 13.6576 23.6851 15.2176 23.0552 16.678C22.4253 18.1384 21.5704 19.4088 20.4906 20.489C19.4108 21.5693 18.141 22.4246 16.6813 23.0547C15.2215 23.6849 13.6618 24 12.0021 24ZM12 22.1053C14.8211 22.1053 17.2105 21.1263 19.1684 19.1684C21.1263 17.2105 22.1053 14.8211 22.1053 12C22.1053 9.17894 21.1263 6.78946 19.1684 4.83156C17.2105 2.87366 14.8211 1.89471 12 1.89471C9.17894 1.89471 6.78946 2.87366 4.83156 4.83156C2.87366 6.78946 1.89471 9.17894 1.89471 12C1.89471 14.8211 2.87366 17.2105 4.83156 19.1684C6.78946 21.1263 9.17894 22.1053 12 22.1053Z",
    fill: "currentColor"
  }));
};
BlackHorseIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5919 17.67C13.5919 18.5988 13.2245 19.2342 12 19.2342C10.7755 19.2342 10.4082 18.6232 10.4082 17.67V17.5234C10.4082 16.5703 10.7755 15.9348 12 15.9348C13.2245 15.9348 13.5919 16.5703 13.5919 17.5234V17.67ZM10.543 4.888H13.4573V14.4196H10.543V4.888ZM12 0C5.36327 0 0 5.37678 0 12C0 18.6232 5.36327 24 12 24C18.6367 24 24 18.6232 24 12C24 5.37678 18.6367 0 12 0Z",
    fill: "currentColor"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 2.83333C6.93739 2.83333 2.83333 6.93739 2.83333 12C2.83333 17.0626 6.93739 21.1667 12 21.1667C17.0626 21.1667 21.1667 17.0626 21.1667 12C21.1667 6.93739 17.0626 2.83333 12 2.83333ZM12 16C12.5128 16 12.9355 16.3827 12.9933 16.8827L13 17C13 17.5128 12.6173 17.9355 12.1173 17.9933L12 18C11.4872 18 11.0645 17.6173 11.0067 17.1173L11 17C11 16.4872 11.3827 16.0645 11.8827 16.0067L12 16ZM13 6V14H11V6H13Z",
    fill: "currentColor"
  }));
};
HalifaxIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsReimaginedIcon = function LloydsReimaginedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.92 1 1 5.93 1 12C1 18.07 5.92 23 12 23C18.08 23 23 18.08 23 12C23 5.92 18.08 1 12 1ZM11 5H13V14H11V5ZM12 19C11.17 19 10.5 18.33 10.5 17.5C10.5 16.67 11.17 16 12 16C12.83 16 13.5 16.67 13.5 17.5C13.5 18.33 12.83 19 12 19Z",
    fill: "currentColor"
  }));
};
LloydsReimaginedIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5919 17.67C13.5919 18.5988 13.2245 19.2342 12 19.2342C10.7755 19.2342 10.4082 18.6232 10.4082 17.67V17.5234C10.4082 16.5703 10.7755 15.9348 12 15.9348C13.2245 15.9348 13.5919 16.5703 13.5919 17.5234V17.67ZM10.543 4.888H13.4573V14.4196H10.543V4.888ZM12 0C5.36327 0 0 5.37678 0 12C0 18.6232 5.36327 24 12 24C18.6367 24 24 18.6232 24 12C24 5.37678 18.6367 0 12 0Z",
    fill: "currentColor"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM11.7542 16.2801C10.7895 16.2801 10 17.0694 10 18.0342C10 18.9992 10.7894 19.7665 11.7542 19.7665C12.7191 19.7665 13.4865 18.9992 13.4865 18.0342C13.4865 17.0694 12.7191 16.2801 11.7542 16.2801ZM10.6873 10.6436L11.3475 14.4399H11.9664L12.606 10.6436C12.6221 10.5524 12.6387 10.4591 12.6555 10.3641C12.8978 8.9983 13.2043 7.2705 13.2043 5.93963C13.2043 4.94913 12.7712 4 11.6569 4C10.5223 4 10.1096 4.94909 10.1096 5.93963C10.1096 7.36308 10.4398 9.24061 10.6873 10.6436Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
MbnaIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.9997C0 5.37273 5.37232 0 12 0C18.6277 0 24 5.37273 24 12.0003C24 18.6273 18.6277 24 12 24C5.37232 24 0 18.6273 0 11.9997ZM11.7877 14.2827H12.2846C12.6895 14.2827 13.0391 13.9772 13.0575 13.6038L13.4992 7.6789C13.5176 7.30549 13.2048 6 12.7999 6H11.1987C10.8307 6 10.4994 7.27155 10.5178 7.66192L10.9963 13.5699C11.0147 13.9603 11.3828 14.2827 11.7877 14.2827ZM11.9915 18C12.826 18 13.4829 17.3294 13.4829 16.5C13.4829 15.6706 12.826 15.0001 11.9915 15.0001C11.157 15.0001 10.5 15.6706 10.5 16.5C10.5 17.3294 11.157 18 11.9915 18Z",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { LLOYDS, BIRMINGHAM_MIDSHIRES, BLACK_HORSE, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT, BOS, HALIFAX, LLOYDS2023, MBNA, SCOTTISH_WIDOWS } from "../../constants";
export default function Negative(_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme();
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.negative) {
    svg = theme.assets.icons.negative;
  } else {
    switch (brand) {
      case BIRMINGHAM_MIDSHIRES:
        svg = BirminghamMidshiresIcon;
        break;
      case BLACK_HORSE:
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = BlackHorseIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsReimaginedIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      default:
        console.warn("Icon \"Negative\" is not available for brand ".concat(brand));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}